'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/monthsAgo.js
// module id = 341
// module chunks = 0